import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import styles from '../component-styles/footer.module.scss'
import { logout } from '../api-client/user-client'
import { UserState } from '../store/user-reducer'
import { GraphQLState } from '../store/graphql-reducer'

interface Props {
  className?: string
}

export default function Footer({ className }: Props): React.ReactElement {
  const {
    graphql: { currentUser },
    user: { authenticated },
  }: {
    graphql: GraphQLState
    user: UserState
  } = useSelector((s: any): any => s)

  const showLoggedIn = authenticated && currentUser && currentUser.email
  return (
    <footer className={classNames(styles.container, className)}>
      {showLoggedIn && currentUser !== null && (
        <p>
          <>
            Logged in as <strong>{currentUser.email}</strong>
            {currentUser.currentAccountPermission !== 'regular'
              ? ` (${currentUser.currentAccountPermission})`
              : ''}
            .
          </>
          <Link to="/login" onClick={logout}>
            {' '}
            Logout
          </Link>
        </p>
      )}
      {!showLoggedIn && (
        <p className={styles.links}>
          <a
            href="https://support.uplifter.ai/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help centre
          </a>
        </p>
      )}
      <div className={styles.rightColumn}>
        {showLoggedIn && (
          <p className={styles.links}>
            <a
              href="https://support.uplifter.ai/hc/en-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help Centre
            </a>
          </p>
        )}
        <p className={styles.links}>
          <a
            href="/privacy-statement.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Statement
          </a>
        </p>
        <p>
          © {new Date().getFullYear()}
          {' - '}
          {'Uplifter Ltd. '}
        </p>
      </div>
    </footer>
  )
}
